// 1.引入axios
import axios from "axios";
// 2.引入qs
import qs from "qs";

import router from '../router'

let baseURL = null;

import {error} from '../assets/js/message'
// process中提供了开发环境或者生产环境
// 2.环境的切换
if (process.env.NODE_ENV === "development") {
  // 开发环境
  baseURL = "";
} else if (process.env.NODE_ENV === "production") {
  // 生产环境
  baseURL = "";
}

// 3.自定义axios请求
const instance = axios.create({
  baseURL: baseURL,
  timeout: 500000,
  // headers:{
  //   'X-Request-AccessToken':sessionStorage.getItem('accessToken') || ''
  // }
});
// instance.defaults.headers["X-Request-AccessToken"] = sessionStorage.getItem('accessToken') || '';

// 4.拦截器
// 请求拦截器
instance.interceptors.request.use(
  config => {
    config.headers.ticket = "mock-ticket";
    // config.responseType = "blob";
    // console.group('本次请求的地址为:'+config.url)
    // 令牌的判断
    config.headers["X-Request-AccessToken"] = sessionStorage.getItem('accessToken')
    config.headers["TGT"] = sessionStorage.getItem('TGT') || ''
    console.log("本次请求的地址为:" + config.url);
    return config;
  },
  err => {
    // 请求失败的结果
    return Promise.reject(err);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  res => {
    // console.log('响应拦截器',res)
    // if(res.status==200){
    //   return res
    // }

      if(res.data.code == -1){
        if(res.data.message=='登录号错误或不存在'){
          error(res.data.message)
          return
        }else if(res.data.message=='系统错误'){
          error(res.data.message)
          return
        }else{
          error(res.data.message)
          return router.push('/')
        }
      }
    // console.group('本次响应的地址为:'+res.config.url)
    return res;
  },
  err => {
    return Promise.reject(err);
  }
);

// 封装get请求
export function get(url, params = null) {
  /**
   * 1.得到Promise对象,
   * 2.在实例化中需要传递一个参数,该参数是一个function
   * 3.function中接受两个参数: resolve reject
   *  参数一:resolve  操作成功返回的结果
   * 参数二: reject   操作失败返回的结果
   */
  return new Promise((resolve, reject) => {
    // 发起真正的请求
    instance
      .get(url, {
        params,
        paramsSerializer(params) {
          return qs.stringify(params, {
            arrayFormat: "repeat",
            allowDots: true
          });
        }
      })
      .then(res => {
        // 返回成功的结果
        resolve(res);
      })
      .catch(err => {
        // 返回失败的结果
        reject(err);
      });
  });
}

// 封装post请求
export function post(url, params, isFile = false) {
  // 设置请求头
  let config = {
    headers: {
      "Content-Type": "application/json; charset=UTF-8"
    }
  };
  // 参数序列化
  // let data = qs.stringify(params)
  let data = params;
  // 有文件
  if (isFile) {
    config = {
      headers: {
        "Content-Type": "mutiple/form-data"
      }
    };
    // data = new FormData();
    // for (let i in params) {
    //   console.log('序列化',i,params[i])
    //   data.append(i, params[i]);
    // }
  }

  return new Promise((resolve, reject) => {
    // 发起post请求
    instance
      .post(url, data, config)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}


// 封装delete请求
export function del(url, params = null) {
  return new Promise((resolve, reject) => {
    // 发起真正的请求
    instance.delete(url, params).then(res => {
        // 返回成功的结果
        resolve(res);
      }).catch(err => {
        // 返回失败的结果
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js